import { module } from 'modujs'
import { $html } from '../utils/dom';
import LocomotiveScroll from 'locomotive-scroll'
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { BREAKPOINTS } from '../config';

gsap.registerPlugin(ScrollTrigger);

export default class Scroll extends module {
    static MQ_SMOOTH = `(prefers-reduced-motion: no-preference)`;
    static MQ_ANIM = `(max-width: ${BREAKPOINTS.TO_SM}px)`;
    static MQ_POINTER = `(pointer:coarse)`;

    constructor(m) {
        super(m);

        gsap.defaults({ease: "none"});
        gsap.config({force3D: true});

        this.isStopped = false
        this.onScroll = this.onScroll.bind(this)
    }

    init() {
        this.scroll = new LocomotiveScroll({
            modularInstance: this,
            scrollCallback: this.onScroll,
            lenisOptions: {
                smoothWheel: window.matchMedia(Scroll.MQ_SMOOTH).matches
            }
        })

        // Force scroll to top
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual'
            window.scrollTo(0, 0)
        }

        this.scroll.lenisInstance.options.content.addEventListener('wheel', (event) => {
            const targets = event.composedPath();

            const stopPropagation = targets.some(target => target.id === 'cc-main');
            if (stopPropagation) {
                event.stopPropagation();
            }
        });
    }

    onScroll({ scroll, progress }) {
        // Show / Hide fixed header
        if (scroll > 10 && !$html.classList.contains('has-scrolled')) {
            $html.classList.add('has-scrolled')
        } else if (scroll <= 10 && $html.classList.contains('has-scrolled')) {
            $html.classList.remove('has-scrolled')
        }

        const animationParams = {
            yPercent: progress > 0.8 ? -100 : 100,
            autoAlpha: progress > 0.8 ? 1 : 0,
            duration: 0.4,
            ease: 'power2.Out'
        };

        if (document.querySelector('.-fixed')) {
            gsap.to('.-fixed', animationParams);
        }
    }

    imagerie() {
        if (window.matchMedia(Scroll.MQ_ANIM).matches) return;

        // Définir la valeur de start en fonction de MQ_POINTER
        const startValue = window.matchMedia(Scroll.MQ_POINTER).matches ? '10% -1%' : '0% -1%';
    
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.c-hero_inner',
                start: startValue, // Utilisation de la valeur dynamique
                end: '+=500',
                scrub: 1
            }
        });

        tl.to('.c-home .colored-wheel, .c-home .stripes ', { y: "100%", duration: .4, ease: 'power2.out' })
            .to('.c-home .cloud', { y: "110%", duration: .6, ease: 'power2.out' }, '<')
            .to('.c-home .back-wheel', { y: "100%", duration: .4, ease: 'power2.out' }, '<.2')
            .to('.c-home .yellow-wheel', { y: "100%", duration: .4, ease: 'power2.out' }, '<')
            .to('.c-home .side-clouds.left', { x: "-105%", rotate: 24, duration: .8, ease: 'power2.out' }, '<-.06')
            .to('.c-home .side-clouds.right', { x: "105%", rotate: -24, duration: .8, ease: 'power2.out' }, '<')
    }

    scrollTo(params) {
        let { target, options } = params
        options = Object.assign({}, options)
        this.scroll?.scrollTo(target, options)
    }

    addScrollElements(container) {
        this.scroll.addScrollElements(container)
    }

    removeScrollElements(container) {
        this.scroll.removeScrollElements(container)
    }

    stop() {
        if (this.isStopped) return

        this.scroll?.lenisInstance.stop()
        this.isStopped = true
    }

    start() {
        if (!this.isStopped) return

        this.scroll?.lenisInstance.start()
        this.isStopped = false
    }

    cardInview(el) {
        if (window.matchMedia(Scroll.MQ_ANIM).matches) return;
        gsap.set(el.target, {
            top: '62vh',
            rotation: () => { return (Math.random() - 0.5) * 20 },
        })

        gsap.to('.c-tile', {
            top: 0,
            rotate: 0,
            ease: 'power2.out',
            duration: .8,
            stagger: .07,
            scrollTrigger: {
                trigger: el.target.parentNode,
                start: '0% 90%'
            }
        })
    }

    triggerCta() {
        gsap.to('.-fixed', {
            yPercent: -100,
            opacity: 1,
            duration: .4,
            ease: 'power2.Out'
        })
    }

    destroy() {
        this.scroll.destroy();
    }
}
